export default __webpack_public_path__ + "static/media/chat.53644357.jpg";